<template>
  <a-result
    status="403"
    title="403"
    sub-title="You do not have permission to access this page."
  >
    <template #extra>
      <span class="font-semibold text-white">
        <button
          onclick="history.back()"
          class="rounded-button"
          type="submit"
          name="go-back"
        >
          Go Back
        </button>
      </span>
    </template>
  </a-result>
</template>
